export default "__VITE_ASSET__IOaSG_nE__"